<template>
    <router-view></router-view>
</template>

<style lang="less">
@import 'element-plus/dist/index.css';
html, body{
  
    margin: 0;
    padding: 0;
    // overflow: hidden;
    height: 100%;
    // background-color: #1e1e1edd;
}
#app {
  height: 100vh;
  overflow: auto; // 允许页面滚动
}

// 修复 Element 组件需要的溢出显示
.el-select__popper,
.el-dropdown__popper,
.el-menu--popup {
  overflow: visible !important;
}
</style>
